module.exports = __webpack_public_path__ + "wedding_elegant-wedding_1.jpg";